const GROUP_PATHS = {
  dashboard: ["dashboard"],
  task: ["task", "messages"],
  messages: ["task", "messages"],
  inspections: [
    "inspections",
    "checklists",
    "visitors",
    "safety",
    "certification",
    "document-control",
  ],
  checklists: [
    "inspections",
    "checklists",
    "visitors",
    "safety",
    "certification",
    "document-control",
  ],
  visitors: [
    "inspections",
    "checklists",
    "visitors",
    "safety",
    "certification",
    "document-control",
  ],
  safety: [
    "inspections",
    "checklists",
    "visitors",
    "safety",
    "certification",
    "document-control",
  ],
  certification: [
    "inspections",
    "checklists",
    "visitors",
    "safety",
    "certification",
    "document-control",
  ],
  "document-control": [
    "inspections",
    "checklists",
    "visitors",
    "safety",
    "certification",
    "document-control",
  ],
  production: ["production", "recipe", "assemblies"],
  recipe: ["production", "recipe", "assemblies"],
  assemblies: ["production", "recipe", "assemblies"],
  inventory: [
    "inventory",
    "ingredients",
    "materials",
    "finished-goods",
    "inventory/lot-documentation",
  ],
  ingredients: [
    "inventory",
    "ingredients",
    "materials",
    "finished-goods",
    "inventory/lot-documentation",
  ],
  materials: [
    "inventory",
    "ingredients",
    "materials",
    "finished-goods",
    "inventory/lot-documentation",
  ],
  "finished-goods": [
    "inventory",
    "ingredients",
    "materials",
    "finished-goods",
    "inventory/lot-documentation",
  ],
  "lot-documentation": [
    "inventory",
    "ingredients",
    "materials",
    "finished-goods",
    "inventory/lot-documentation",
  ],
  assets: [
    "assets",
    "assets/list",
    "assets/asset-groups",
    "assets/work-orders",
    "assets/repeating-work-orders",
  ],
  customers: ["customers", "customer_orders"],
  customer_orders: ["customers", "customer_orders"],
  supplier: ["supplier", "manufacturer", "co-packer", "purchase-orders"],
  manufacturer: ["supplier", "manufacturer", "co-packer", "purchase-orders"],
  "co-packer": ["supplier", "manufacturer", "co-packer", "purchase-orders"],
  copacker: ["supplier", "manufacturer", "co-packer", "purchase-orders"],
  "purchase-orders": ["supplier", "manufacturer", "co-packer", "purchase-orders"],
  orders: ["supplier", "manufacturer", "co-packer", "purchase-orders"],
  employees: ["employees", "teams", "roles", "users"],
  teams: ["employees", "teams", "roles", "users"],
  roles: ["employees", "teams", "roles", "users"],
  users: ["employees", "teams", "roles", "users"],
  "my-settings": ["my-settings", "global-settings", "company"],
  "global-settings": ["my-settings", "global-settings", "company"],
  company: ["my-settings", "global-settings", "company"],
  reports: ["reports"],
};

const PATH_ALIASES = {
  copacker: "co-packer",
  orders: "purchase-orders",
  "lot-documentation": "inventory/lot-documentation",
};

const ROUTE_LOADERS = {
  dashboard: [() => import("../containers/dashboard")],
  company: [() => import("../containers/Company/index")],
  employees: [() => import("../containers/Employee/index")],
  teams: [() => import("../containers/Teams/index")],
  roles: [() => import("../containers/Roles/index")],
  users: [() => import("../containers/Users/index")],
  manufacturer: [() => import("../containers/Manufacturer/index")],
  "co-packer": [() => import("../containers/CoPacker/index")],
  supplier: [() => import("../containers/Supplier/index")],
  certification: [
    () =>
      import("../containers/GlobalCertification/GlobalCertificationModule"),
  ],
  "document-control": [
    () => import("../containers/DocumentControl/DocumentControlModule"),
  ],
  customers: [() => import("../containers/Customers")],
  customer_orders: [() => import("../containers/CustomerOrders")],
  ingredients: [() => import("../containers/Ingredients/index")],
  "finished-goods": [() => import("../containers/FinishedGoods/index")],
  inventory: [() => import("../containers/Inventory/index")],
  "inventory/lot-documentation": [
    () => import("../containers/Inventory/index"),
    () => import("../containers/LotDocumentation/LotDocumentation"),
  ],
  assets: [() => import("../containers/Assets/index")],
  "assets/list": [
    () => import("../containers/Assets/index"),
    () => import("../containers/Assets/EquipmentAssetList"),
  ],
  "assets/asset-groups": [
    () => import("../containers/Assets/index"),
    () => import("../containers/Assets/AssetGroups"),
  ],
  "assets/work-orders": [
    () => import("../containers/Assets/index"),
    () => import("../containers/Assets/WorkOrders"),
  ],
  "assets/repeating-work-orders": [
    () => import("../containers/Assets/index"),
    () => import("../containers/Assets/RepeatingWorkOrders"),
  ],
  "purchase-orders": [() => import("../containers/Orders/index")],
  inspections: [() => import("../containers/Inspection/index")],
  checklists: [() => import("../containers/Checklist/index")],
  recipe: [() => import("../containers/Recipes/index")],
  assemblies: [() => import("../containers/Assemblies/index")],
  materials: [() => import("../containers/Materials/index")],
  messages: [() => import("../containers/Messages/index")],
  reports: [() => import("../containers/Reports")],
  visitors: [() => import("../containers/Visitor/index")],
  plan_detail: [() => import("../containers/PlanDetails/index")],
  "my-settings": [() => import("../containers/MySettingsModule")],
  "global-settings": [() => import("../containers/SettingsModule")],
  companyDetails: [() => import("../containers/CompanyDetails/index")],
  task: [() => import("../containers/Task/index")],
  production: [() => import("../containers/Production/index")],
  editProfile: [() => import("../components/user/editProfile")],
  viewProfile: [() => import("../components/user/ViewProfile")],
  safety: [() => import("../containers/Safety/index")],
  cards: [() => import("../containers/Page/CardDisplayPage")],
  companies: [() => import("../containers/Companies/index")],
  membership: [() => import("../containers/GlobalMembership/index")],
  units: [() => import("../containers/Units/index")],
  feedback: [() => import("../containers/Feedbacks/index")],
  globalsafetycertificates: [
    () => import("../containers/Safety/GlobalSafetyCertificateModule"),
  ],
  globalingredient: [
    () => import("../containers/GlobalIngredient/GlobalIngredientPage"),
  ],
  allergens: [() => import("../containers/Allergens/AllergenModule")],
  "usda-ingredients": [() => import("../containers/UsdaIngredients/index")],
  "ffl-analytics": [() => import("../containers/FflAnalytics/index")],
  "signup-access": [() => import("../containers/SignupAccess/index")],
};

function normalizePath(path) {
  return String(path || "")
    .trim()
    .replace(/^\/+/, "")
    .split("?")[0]
    .split("#")[0]
    .replace(/\/+$/, "");
}

function findLoaders(normalizedPath) {
  const aliased = PATH_ALIASES[normalizedPath] || normalizedPath;
  if (ROUTE_LOADERS[aliased]) {
    return ROUTE_LOADERS[aliased];
  }
  const firstSegment = aliased.split("/")[0];
  const firstAliased = PATH_ALIASES[firstSegment] || firstSegment;
  return ROUTE_LOADERS[firstAliased] || [];
}

function runLoaders(loaders) {
  loaders.forEach((load) => {
    try {
      const result = load();
      if (result && typeof result.catch === "function") {
        result.catch(() => {});
      }
    } catch (error) {
      // Prefetch must never affect navigation.
    }
  });
}

export function prefetchRoute(path) {
  const normalized = normalizePath(path);
  if (!normalized) {
    return;
  }
  runLoaders(findLoaders(normalized));
}

export function prefetchRoutes(paths) {
  if (!Array.isArray(paths)) {
    return;
  }
  paths.forEach((path) => prefetchRoute(path));
}

export function prefetchGroupForPath(path) {
  const normalized = normalizePath(path);
  if (!normalized) {
    return;
  }
  const firstSegment = normalized.split("/")[0];
  const group = GROUP_PATHS[firstSegment] || GROUP_PATHS[normalized];
  if (group) {
    prefetchRoutes(group);
    return;
  }
  prefetchRoute(normalized);
}

export function prefetchMenuItem(menuItemData) {
  if (!menuItemData) {
    return;
  }
  if (menuItemData.route) {
    prefetchRoute(menuItemData.route);
  }
  if (Array.isArray(menuItemData.modules)) {
    prefetchRoutes(menuItemData.modules);
  }
}

function shouldSkipIdlePrefetch() {
  if (typeof navigator === "undefined") {
    return false;
  }
  const connection =
    navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!connection) {
    return false;
  }
  return Boolean(
    connection.saveData ||
      connection.effectiveType === "slow-2g" ||
      connection.effectiveType === "2g"
  );
}

export function scheduleIdlePrefetch(paths) {
  if (!Array.isArray(paths) || paths.length === 0 || shouldSkipIdlePrefetch()) {
    return;
  }
  const uniquePaths = Array.from(
    new Set(paths.map((path) => normalizePath(path)).filter(Boolean))
  );
  let index = 0;
  const runNext = () => {
    if (index >= uniquePaths.length) {
      return;
    }
    prefetchRoute(uniquePaths[index]);
    index += 1;
    if (index >= uniquePaths.length) {
      return;
    }
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(runNext, { timeout: 2000 });
      return;
    }
    setTimeout(runNext, 350);
  };
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(runNext, { timeout: 1500 });
    return;
  }
  setTimeout(runNext, 800);
}
